'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadFile = exports.checkUploadFileStatus = exports.upload = exports.getUploadToken = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _XMLHttpRequest = require('../components/FileUpload/utils/XMLHttpRequest');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUploadToken = exports.getUploadToken = function getUploadToken(_ref) {
  var getFileTokenUrl = _ref.getFileTokenUrl,
      _ref$requestPayLoad = _ref.requestPayLoad,
      requestPayLoad = _ref$requestPayLoad === undefined ? {} : _ref$requestPayLoad,
      name = _ref.name;

  var requestData = (0, _extends3.default)({}, requestPayLoad, { name: name });
  return (0, _XMLHttpRequest.makeRequest)({
    method: 'POST',
    url: getFileTokenUrl,
    params: (0, _stringify2.default)(requestData),
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

var upload = exports.upload = function upload(_ref2) {
  var uploadFileUrl = _ref2.uploadFileUrl,
      file = _ref2.file,
      fileToken = _ref2.fileToken;

  var formData = new FormData();
  formData.append('file', file);
  return (0, _XMLHttpRequest.makeRequest)({ method: 'POST', url: uploadFileUrl + '/' + fileToken, params: formData });
};

var checkUploadFileStatus = exports.checkUploadFileStatus = function checkUploadFileStatus(_ref3) {
  var getFileStatusUrl = _ref3.getFileStatusUrl,
      fileToken = _ref3.fileToken;

  return (0, _XMLHttpRequest.makeRequest)({ method: 'GET', url: getFileStatusUrl + '/' + fileToken });
};

var intervalID = 0;
var isTimerExpired = false;

var clearTimer = function clearTimer() {
  isTimerExpired = true;clearInterval(intervalID);
};

var checkUploadFileStatusWithTimer = function checkUploadFileStatusWithTimer(getFileStatusUrl, fileToken) {
  return new _promise2.default(function (resolve, reject) {
    intervalID = setInterval(function () {
      checkUploadFileStatus({ getFileStatusUrl: getFileStatusUrl, fileToken: fileToken }).then(function (response) {
        dealFileStatus({ response: response, resolve: resolve, reject: reject });
      }).catch(function (error) {
        reject(error);
      });
    }, 1000);
  });
};

var dealFileStatus = function dealFileStatus(_ref4) {
  var response = _ref4.response,
      resolve = _ref4.resolve,
      reject = _ref4.reject;

  if (!isTimerExpired) {
    var responseJSON = JSON.parse(response);
    if ((0, _isEqual2.default)(responseJSON.state, 'AVAILABLE')) {
      resolve(responseJSON);
      clearTimer();
    } else if ((0, _isEqual2.default)(responseJSON.state, 'UNAVAILABLE')) {
      reject(responseJSON);
      clearTimer();
    }
  }
};

var uploadFile = exports.uploadFile = function uploadFile(_ref5, requestPayLoad, file) {
  var getFileTokenUrl = _ref5.getFileTokenUrl,
      getFileStatusUrl = _ref5.getFileStatusUrl,
      uploadFileUrl = _ref5.uploadFileUrl;

  isTimerExpired = false;
  return new _promise2.default(function (resolve, reject) {
    getUploadToken({ getFileTokenUrl: getFileTokenUrl, requestPayLoad: requestPayLoad, name: file.name }).then(function (fileToken) {
      return upload({ uploadFileUrl: uploadFileUrl, file: file, fileToken: fileToken });
    }).then(function (fileToken) {
      return checkUploadFileStatusWithTimer(getFileStatusUrl, fileToken);
    }).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      clearTimer();
      reject(error);
    });
  });
};